import styled from '@emotion/styled'
import { CSSProperties } from 'react'
import { MEDIUM_GRAY, ORANGE } from '../constant/colors'
import Text from './common/Text'

const PriceStyle = styled(Text)<{
  priceType: 'display' | 'additional'
}>`
  text-decoration: ${({ priceType }) => priceType === 'additional' && 'line-through'};
  color: ${({ priceType }) => (priceType === 'additional' ? MEDIUM_GRAY : ORANGE)};
  white-space: pre;
`

type PriceFormatterProps = {
  fontSize?: number
  lineHeight?: number
  priceType: 'display' | 'additional'
  style?: CSSProperties
  value: number
}

const PriceFormatter = (props: PriceFormatterProps) => {
  const { fontSize = 16, lineHeight, priceType, style, value } = props
  const defaultLineHeight = fontSize + 4
  const isAdditional = priceType === 'additional'

  const formatter = (data: number) => {
    return `${data}`.replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
  }

  return (
    <PriceStyle
      priceType={priceType}
      type={isAdditional ? 'Regular' : 'SemiBold'}
      size={fontSize}
      style={{ ...style, lineHeight: `${lineHeight || defaultLineHeight}px` }}
    >
      {`${formatter(value)}฿`}
    </PriceStyle>
  )
}
export default PriceFormatter
